/**
 * Pure rich-text value helpers, dependency-free so display-logic modules the
 * mobile shell also imports (initiativeDisplay.ts) can use them without
 * pulling the RichContent component (react + dompurify) into their chunk.
 * RichContent re-exports these for its existing importers.
 */

/**
 * True when a rich-text value holds no actual content. Quill represents an
 * empty editor as `<p><br></p>`, so a bare trim() check reads it as filled —
 * use this wherever "did the admin write anything?" gates behavior.
 */
export const richTextIsEmpty = (value: string | null | undefined): boolean => {
  if (!value) return true;
  return value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() === '';
};

/** The value to persist: '' for an empty editor, the markup otherwise. */
export const normalizeRichText = (value: string | null | undefined): string =>
  richTextIsEmpty(value) ? '' : (value as string);
